import { render, staticRenderFns } from "./salary-toolbar.vue?vue&type=template&id=07ded0e2&scoped=true&"
import script from "./salary-toolbar.ts?vue&type=script&lang=ts&"
export * from "./salary-toolbar.ts?vue&type=script&lang=ts&"
import style0 from "./salary-toolbar.vue?vue&type=style&index=0&id=07ded0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ded0e2",
  null
  
)

export default component.exports